import { render, staticRenderFns } from "./brandOverview.vue?vue&type=template&id=64860257&scoped=true&"
import script from "./brandOverview.vue?vue&type=script&lang=js&"
export * from "./brandOverview.vue?vue&type=script&lang=js&"
import style0 from "./brandOverview.vue?vue&type=style&index=0&lang=css&"
import style1 from "./brandOverview.vue?vue&type=style&index=1&id=64860257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64860257",
  null
  
)

export default component.exports